import type { VariantProps } from 'tailwind-variants';
import { tv } from '../tv';
import { CONTAINER_COLOR_VARIANTS } from '../variants';

export const containerColor = tv({
	base: 'border-(--v-container-line) bg-(--v-container) text-(--v-on-container) outline-(--v-container-line) focus-visible:bg-(--v-container-hover) [&:is(button)]:aria-pressed:bg-(--v-container-active) [&:is(button)]:disabled:opacity-disabled [&:is(button):active]:bg-(--v-container-active) [&:is(button):hover]:bg-(--v-container-hover)',
	variants: { variant: CONTAINER_COLOR_VARIANTS },
	defaultVariants: { variant: 'Surface' }
});

export type ContainerColorVariants = VariantProps<typeof containerColor>;
